import { ApproversResponse } from "@api";
import { StyledTableCell } from "@components";
import { faCheckCircle, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontStyle: "italic",
  },
  green: {
    color: "green",
  },
  blue: {
    color: "#0f7dca",
  },
}));

interface Props {
  approvers: ApproversResponse;
}

export const ApproversDetails: React.FC<Props> = ({ approvers }) => {
  const classes = useStyles();

  const {
    approver1,
    approvalDistroName1,
    approvedBy1,
    approver2,
    approvalDistroName2,
    approvedBy2,
    approver3,
    approvalDistroName3,
    approvedBy3,
    approver4,
    approvalDistroName4,
    approvedBy4,
  } = approvers;

  let approver1Icon = null;
  const approver1Text = !!approvedBy1
    ? approvedBy1
    : !!approver1
    ? approver1
    : approvalDistroName1;

  if (!!approver1 || !!approvalDistroName1) {
    if (!!approvedBy1) {
      approver1Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else {
      approver1Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  let approver2Icon = null;
  const approver2Text = !!approvedBy2
    ? approvedBy2
    : !!approver2
    ? approver2
    : approvalDistroName2;

  if (!!approver2 || !!approvalDistroName2) {
    if (!!approvedBy2) {
      approver2Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else if (!!approver2 || !!approvalDistroName2) {
      approver2Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  let approver3Icon = null;
  const approver3Text = !!approvedBy3
    ? approvedBy3
    : !!approver3
    ? approver3
    : approvalDistroName3;

  if (!!approver3 || !!approvalDistroName3) {
    if (!!approvedBy3) {
      approver3Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else if (!!approver3 || !!approvalDistroName3) {
      approver3Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  let approver4Icon = null;
  const approver4Text = !!approvedBy4
    ? approvedBy4
    : !!approver4
    ? approver4
    : approvalDistroName4;

  if (!!approver4 || !!approvalDistroName4) {
    if (!!approvedBy4) {
      approver4Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else if (!!approver4 || !!approvalDistroName4) {
      approver4Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1">Approvers</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="body1"
          color="textSecondary"
          className={classes.root}
        >
          <Box component="span">
            <Box component="span">
              <FontAwesomeIcon icon={faClock} className={classes.blue} />{" "}
              Approval in Progress
            </Box>
            <Box component="span" ml={3}>
              <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />{" "}
              Approved
            </Box>
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">Approver 1</StyledTableCell>
                <StyledTableCell align="center">Approver 2</StyledTableCell>
                <StyledTableCell align="center">Approver 3</StyledTableCell>
                <StyledTableCell align="center">Approver 4</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center">
                  {approver1Icon} {approver1Text}
                </TableCell>
                <TableCell align="center">
                  {approver2Icon} {approver2Text}
                </TableCell>
                <TableCell align="center">
                  {approver3Icon} {approver3Text}
                </TableCell>
                <TableCell align="center">
                  {approver4Icon} {approver4Text}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
